<template>
	<home-tile
		:button-title="generateButtonTitle(failedPayout)"
		@click="showCard"
		v-if="failedPayout"
		color="danger"
		v-bind:style="{ paddingTop: '50px' }"
	>
		<img class="tile-image" src="@/assets/creditCard.svg" />
		<h3 class="tile-header" style="margintop: -35px">
			Oops! Your Last Donation Failed
		</h3>
		<div style="padding: 0 30px">
			<span class="tile-text-small"
				>Card Information: {{ cardBrand }} **{{ cardLast4 }}</span
			>
			<span class="tile-text-small">Payment Error:</span>
			<span class="tile-text-small">{{ failedPayout }}</span>
		</div>
	</home-tile>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import HomeTile from './HomeTile'

export default {
	name: 'roundups-error-tile',
	components: { HomeTile },
	computed: {
		...mapGetters(['failedPayout']),
		...mapState({
			cardBrand: ({ me }) => me.current.card_brand,
			cardLast4: ({ me }) => me.current.card_last_four
		})
	},
	methods: {
		...mapActions(['getHome']),
		showCard() {
			const acceptibleErrors = [
				'Your card was declined.',
				'Your card has insufficient funds.',
				'An error occurred with our connection to Stripe.'
			]
			if (acceptibleErrors.includes(this.failedPayout)) {
				this.navigate({ name: 'roundups' }, 'forward')
			} else {
				this.navigate({ name: 'card' }, 'forward')
			}
		},
		generateButtonTitle() {
			const acceptibleErrors = [
				'Your card was declined.',
				'Your card has insufficient funds.',
				'An error occurred with our connection to Stripe.'
			]
			if (acceptibleErrors.includes(this.failedPayout)) {
				return 'View Transactions'
			} else {
				return 'Re-Add Card'
			}
		}
	}
}
</script>

<style lang="scss"></style>
